module.exports = __webpack_public_path__ + "img/组 126(2).04dadbc6.png";